import moment from 'moment';
export default {
	getSearchMonths_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).format('YYYY-MM-DD'), moment(endDt).format('YYYY-MM-DD')];
	},
	gridUseYnList_({ useYnList }) {
		const list = [];
		useYnList.length && useYnList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//유형 selectBox
	getPartClList_({ partClList }) {
		const list = [];
		partClList.length && partClList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//종합판정 selectBox
	getOvrlJgmtList_({ ovrlJgmtList }) {
		const list = [];
		ovrlJgmtList.length && ovrlJgmtList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사상태 selectBox
	getPgsStPcList_({ pgsStPcList }) {
		const list = [];
		pgsStPcList.length && pgsStPcList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	}
};
